import constants from "utils/constants"
import Icon from "../Icon/Icon"
interface TipProps {
    className?: string
    icon?: string
    title?: string
    description?: string
    showSupportEmail?: boolean
}
export const Tip: React.FC<TipProps> = (props) => {
    const { className, icon, title, description, showSupportEmail } = props
    return <div className={`flex items-start gap-4 mt-4 w-full ${className}`}>
        {icon && <Icon name={icon} className="mt-1" />}
        <div className="flex max-w-md flex-col justify-start text-left">
            {title && <h1 className="capitalize text-lg font-bold text-gray-200">{title}</h1>}
            <span>
                {description && description}
                {showSupportEmail &&
                    <a href={`mailto:${constants.COMPANY_1_EMAIL_SUPPORT}`} className="text-primary-500 ml-1 underline hover:opacity-80" >
                        {constants.COMPANY_1_EMAIL_SUPPORT}
                    </a>
                }
            </span>
        </div>
    </div>
}